import Marionette from 'backbone.marionette';
import billListItemview from './bill_list_itemview';
import billListCompositeviewTmpl from '../templates/bill_list_compositeview.tpl';
export default Marionette.CompositeView.extend({
  template: billListCompositeviewTmpl,
  childView: billListItemview,
  tagName: 'table',
  className: "table table-hover table-striped",
  childViewContainer: "tbody",
  id: "bill-table",
  onShow: function () {
    $("#bill-table").dataTable({
      bSort: true,
      order: [[2, 'asc']],
      // sort by most recent date
      pagingType: 'simple',
      responsive: true,
      //lengthChange: false,
      //bFilter: false,
      //pageLength: 10,
      columnDefs: [{
        className: "nowrap",
        targets: [0, 2]
      }, {
        responsivePriority: 1,
        targets: [0, 1]
      },
      // (I think this is what shows on iPhone 4)
      {
        responsivePriority: 2,
        targets: [0, 1, 2]
      } // (should show on all other phones)
      //{ responsivePriority: 3, targets: [0, 1] }, // (tablets)
      //{ responsivePriority: 4, targets: [0, 1, 2] },
      ],

      "autoWidth": false
    });
  }
});